import { ThreeCircles } from "react-loader-spinner"

export const ProcessingIcon = ({ merchant }) => {

  const primary = merchant?.colourSet?.button || "#e4e4e7";

  // Todo cusom colors
  return (<ThreeCircles height={64} width={64} className="size-16" color={primary} />);

};
